import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import UnstyledButton from '../../unstyled-button';

const TablePagination = ({ paging, paginateTable }) => (
  <PaginationWrap role="navigation" aria-label="Pagination Navigation">

    <div style={{ marginLeft: 'auto' }}>
      {paging && paging.previousUrl &&
        <PaginationButton
          onClick={() => { paginateTable(paging.previousUrl); }}
          aria-label="Previous page"
        >
          {paging.pages
            ? <Fragment>&larr;</Fragment>
            : <Fragment>Previous</Fragment>
          }
        </PaginationButton>
      }

      {paging && paging.pages && paging.pages.length > 1 &&
        paging.pages.map(page => (
          <PaginationButton
            onClick={() => { paginateTable(page.url); }}
            aria-label={`Goto page ${page.pageNumber}`}
            aria-current={page.pageNumber === paging.currentPage}
            key={page.url}
          >
            {page.pageNumber}
          </PaginationButton>
        ))
      }

      {paging && paging.nextUrl &&
        <PaginationButton
          onClick={() => { paginateTable(paging.nextUrl); }}
          aria-label="Next page"
        >
          {paging.pages
            ? <Fragment>&rarr;</Fragment>
            : <Fragment>Next</Fragment>
          }
        </PaginationButton>
      }
    </div>
  </PaginationWrap>
);

const PaginationWrap = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: .75rem;
  min-height: 18px;
`;

const PaginationButton = styled(UnstyledButton)`
  display: inline-block;
  font-size: .875rem;
  transition: color .25s ease;
  color: #757575;

  &:hover {
    color: ${props => props.theme.blue};
  }

  &:not(:first-of-type) {
    margin-left: 1.5rem;
  }

  &[aria-current="true"] {
    color: ${props => props.theme.blue};
    font-weight: 600;
  }
`;

TablePagination.propTypes = {
  paging: PropTypes.object,
  paginateTable: PropTypes.func,
};

export default TablePagination;
